import moment from 'moment-timezone';

import { ArrivalWindow } from '../types/types';

type Params = {
  isUnscheduled: boolean;
  arrivalWindow?: ArrivalWindow;
  isExactTime?: boolean;
  timeZone?: string;
};

export const generateConfirmationArrivalSubtitle = ({
  arrivalWindow,
  isUnscheduled,
  isExactTime,
  timeZone,
}: Params) => {
  if (isUnscheduled) {
    return 'We’ll reach out to you to decide on the date and arrival time.';
  }
  const firstLine = `Arriving on ${moment(arrivalWindow?.date).format('dddd, MMM Do')}`;

  if (isExactTime) {
    return `${firstLine}
At ${arrivalWindow?.time?.from}  ${timeZone ? moment().tz(timeZone).zoneAbbr() : ''}`;
  }
  return `${firstLine}
Between ${arrivalWindow?.time?.from} - ${arrivalWindow?.time?.to} ${timeZone ? moment().tz(timeZone).zoneAbbr() : ''}`;
};

type ContactParams = {
  firstName: string;
  lastName: string;
  phone: string;
  email: string;
};

export const generateConfirmationContactSubtitle = ({ firstName, lastName, phone, email }: ContactParams): string =>
  `${firstName} ${lastName}
${phone}
${email}`;
